import React from "react";
import { InferGetServerSidePropsType } from "next";
import { PageLevelEvents } from "@/components/PageLevelEvents/PageLevelEvents";
import {
  getServerSideProps,
  PageProps,
} from "@/getServerSideProps/getServerSideProps";
import ErrorPage from "@/components/Error/ErrorPage";
import { useVariant } from "@/hooks/useVariant/useVariant";
import { layoutMap } from "@/layouts/layoutMap";
import { Layout6040, Meta } from "..";

export { getServerSideProps } from "@/getServerSideProps/getServerSideProps";

export default function ErrorWrappedPage(
  props: InferGetServerSidePropsType<typeof getServerSideProps>,
) {
  if (props.type === "error") return <ErrorPage />;
  if (props.type !== "success") return null;
  return <Page {...props} />;
}

function Page(props: PageProps) {
  const {
    product,
    pageConfig,
    runtimeConfig,
    experiences,
    experiencesRawString,
    creditOffers,
  } = props;

  const { variant } = useVariant(product);

  const Layout = layoutMap[pageConfig.layout] || Layout6040;

  return (
    <>
      <Meta product={product} />
      <Layout
        product={product}
        runtimeConfig={runtimeConfig}
        pageConfig={pageConfig}
        experiences={experiences}
        experiencesRawString={experiencesRawString}
        creditOffers={creditOffers}
      />
      <PageLevelEvents
        product={product}
        selectedVariant={variant}
        pageConfig={pageConfig}
      />
    </>
  );
}
